<template>
  <div class="notification_contianer">
    <notification-bar
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
    />
  </div>
</template>

<script>
import NotificationBar from "./NotificationBar.vue";
import { mapState } from "vuex";
export default {
  components: {
    NotificationBar,
  },
  computed: {
    ...mapState("notification", ["notifications"]),
    //   CheckSnackbar() {
    //     if (this.notifications[0]) return (this.snackbar = true);
    //     else return (this.snackbar = false);
    //   },
  },
};
</script>

<style scoped>
/* .notification_contianer {
    position: fixed;
    bottom: 0;
    right: 0;
  } */
</style>
